<template>
  <main class="news-page">
    <div class="profile__state">{{ message }}</div>
  </main>
</template>

<script>
// Pagina pe care backend-ul redirecționează după login cu Facebook/Google.
// Token-ul vine în fragmentul URL-ului (#token=...), care nu ajunge la server.
export default {
  name: 'AuthSocialCallbackView',

  data() {
    return {
      message: 'Se finalizează autentificarea...',
    };
  },

  async mounted() {
    const params = new URLSearchParams(window.location.hash.slice(1));
    const token = params.get('token');

    window.history.replaceState(null, '', window.location.pathname);

    if (!token) {
      this.message = 'Autentificarea a eșuat. Te rugăm să încerci din nou.';
      return;
    }

    window.localStorage.setItem('auth_token', token);
    window.axios.defaults.headers.common.Authorization = `Bearer ${token}`;

    try {
      const response = await window.axios.get('auth/me');
      const user = response.data?.user;

      window.dispatchEvent(new CustomEvent('user-authenticated', { detail: user }));

      const returnPath = this.popReturnPath();

      if (user?.profile_incomplete) {
        this.$router.replace({ name: 'profile' });
        return;
      }

      this.$router.replace(returnPath);
    } catch {
      window.localStorage.removeItem('auth_token');
      delete window.axios.defaults.headers.common.Authorization;
      this.message = 'Autentificarea a eșuat. Te rugăm să încerci din nou.';
    }
  },

  methods: {
    popReturnPath() {
      let returnPath = '/';

      try {
        returnPath = window.localStorage.getItem('auth_return_path') || '/';
        window.localStorage.removeItem('auth_return_path');
      } catch {
        // localStorage indisponibil — rămânem pe pagina principală
      }

      return returnPath;
    },
  },
};
</script>
